import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import Swiper from 'swiper';
// import webLogin from '@utils/weblogin';
import 'swiper/css/swiper.min.css';
import videoService from '@services/videoService';
export default {
  name: 'LiveRoomIcons',
  components: {},
  props: {
    vid: String,
    hostid: String
  },
  data: function data() {
    return {
      VideoAPIService: null,
      swiperDiv: null,
      rdList: [],
      isShowUp: false
    };
  },
  watch: {},
  methods: {
    gotoUrl: function gotoUrl(url) {
      var otherWindow = window.open(url);
      if (otherWindow) {
        otherWindow.opener = null;
      }
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var countryCode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return util.getI18nCountryCode(_this.$route && _this.$route.params.countryCode);
            case 2:
              countryCode = _context.sent;
              if (!util.isTW(countryCode)) {
                _context.next = 8;
                break;
              }
              _context.next = 6;
              return _this.liveRoomIcons();
            case 6:
              _this.rdList = _context.sent;
              setTimeout(function () {
                _this.swiperDiv = new Swiper('#container', {
                  touchMoveStopPropagation: true,
                  preventClicksPropagation: true,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: false
                  },
                  slidesPerView: 1
                });
              }, 200);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // /**
    //  * 获取推荐的活动 聚合
    //  */
    // async liveRoomIcons() {
    //     const info = webLogin.getAuthentication();
    //     const data = await this.VideoAPIService.liveRoomIcons({
    //         androidid: info.deviceID, alias: 'liveme', vid: this.vid, hostid: this.hostid, action: '[14]', uid: info.uid, tuid: info.uid, token: info.token, uniqid: Math.random(), thirdchannel: 6
    //     });
    //     if (data && data[14] && data[14].data) {
    //         return data[14].data;
    //     } else {
    //         return [];
    //     }
    // }
    /**
         * 获取推荐的活动
         */
    liveRoomIcons: function liveRoomIcons() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.VideoAPIService.commonAnnounceBatch({
                anchorUid: _this2.hostid,
                thirdchannel: 6
              });
            case 2:
              data = _context2.sent;
              if (!data) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", data);
            case 5:
              return _context2.abrupt("return", []);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    this.VideoAPIService = videoService.createApi();
    this.getData();
  }
};